import { styled, FormControlLabel as MuiFormControlLabel } from '@mui/material'

export const FormControlLabel = styled(MuiFormControlLabel)<{ error?: boolean }>(({ error, theme }) => ({
  marginLeft: 0,
  justifyContent: 'space-between',
  width: '100%',
  color: error ? theme.palette.error[500] : 'currentColor',
}))
